export const PUBLIC_API=[
    "/api/Account/verify-token",
    "/api/Account/authenticate"
]